import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../utils/api';

export default function DashboardPage() {
  const [summary, setSummary] = useState(null);
  const [logs, setLogs]       = useState([]);
  const [total, setTotal]     = useState(0);
  const [date, setDate]       = useState(today());
  const [page, setPage]       = useState(1);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (date) params.date = date;
      params.page = page;
      const [sum, logData] = await Promise.all([api.getTodaySummary(), api.getLogs(params)]);
      setSummary(sum); setLogs(logData.logs); setTotal(logData.total);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [date, page]);

  useEffect(() => { load(); }, [load]);

  const totalPages = Math.ceil(total / 20);

  return (
    <div style={{ padding:'1.5rem', maxWidth:1000, margin:'0 auto' }}>
      <h1 style={{ fontWeight:600, fontSize:20, marginBottom:4 }}>Dashboard</h1>
      <p style={{ color:'var(--gray-500)', fontSize:13, marginBottom:'1.5rem' }}>Attendance overview and log history</p>

      {summary && (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:'1.5rem' }}>
          <StatCard label="Checked in today" value={summary.checkedIn} color="#16a34a" />
          <StatCard label="Absent today"     value={summary.absent}    color="#dc2626" />
          <StatCard label="Total employees"  value={summary.total}     color="#2563eb" />
        </div>
      )}

      <div style={{ display:'flex', gap:10, marginBottom:'1rem', flexWrap:'wrap', alignItems:'flex-end' }}>
        <div>
          <div style={{ fontSize:12, fontWeight:500, color:'var(--gray-700)', marginBottom:4 }}>Filter by date</div>
          <input type="date" value={date} onChange={e => { setDate(e.target.value); setPage(1); }} style={{ width:180 }} />
        </div>
        <button className="btn btn-secondary" onClick={() => { setDate(''); setPage(1); }}>Show all</button>
        <button className="btn btn-secondary" onClick={load}>↻ Refresh</button>
      </div>

      <div className="card" style={{ padding:0, overflow:'hidden' }}>
        {loading ? (
          <div style={{ padding:'3rem', textAlign:'center' }}><div className="spinner spinner-dark" style={{ margin:'0 auto' }} /></div>
        ) : logs.length === 0 ? (
          <div style={{ padding:'3rem', textAlign:'center', color:'var(--gray-400)' }}>No records found.</div>
        ) : (
          <div style={{ overflowX:'auto' }}>
            <table>
              <thead>
                <tr>
                  <th>Employee</th>
                  <th className="hide-mobile">Department</th>
                  <th>Check-in time</th>
                  <th>Location</th>
                  <th className="hide-mobile">Coordinates</th>
                </tr>
              </thead>
              <tbody>
                {logs.map(log => (
                  <tr key={log.id}>
                    <td style={{ fontWeight:500 }}>{log.employee_name}</td>
                    <td className="hide-mobile"><span className="badge badge-gray">{log.department}</span></td>
                    <td>{new Date(log.check_in_time).toLocaleString()}</td>
                    <td><span className="badge badge-green">{log.location_name}</span></td>
                    <td className="hide-mobile" style={{ fontFamily:'monospace', fontSize:11, color:'var(--gray-400)' }}>
                      {parseFloat(log.latitude).toFixed(4)}, {parseFloat(log.longitude).toFixed(4)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {totalPages > 1 && (
        <div style={{ display:'flex', gap:6, marginTop:'1rem', justifyContent:'center' }}>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
            <button key={p} onClick={() => setPage(p)}
              className={`btn ${page === p ? 'btn-primary' : 'btn-secondary'}`}
              style={{ minWidth:36, padding:'6px 10px' }}>{p}</button>
          ))}
        </div>
      )}
    </div>
  );
}

const StatCard = ({ label, value, color }) => (
  <div className="card" style={{ textAlign:'center', padding:'1.25rem' }}>
    <div style={{ fontSize:38, fontWeight:700, color }}>{value}</div>
    <div style={{ fontSize:12, color:'var(--gray-500)', marginTop:4 }}>{label}</div>
  </div>
);

const today = () => new Date().toISOString().split('T')[0];
